export default "__VITE_ASSET__Bn_Ihm0v__"